<template>
    <ul class="menus">
        <slot></slot>
    </ul>
</template>

<script setup>
    import { ref, provide } from 'vue';

    // Constants
    const PROVIDE_KEYS = {
        CLOSE_OTHER_SUBMENUS: 'closeOtherSubMenus',
        REGISTER_SUBMENU: 'registerSubMenu'
    };

    // Estado reativo
    const subMenuRefs = ref([]);

    // Funções utilitárias
    const menuUtils = {
        register: (subMenuRef) => {
            subMenuRefs.value.push(subMenuRef);
        },

        closeOthers: (excludeMenuRef = null) => {
            subMenuRefs.value.forEach(menuRef => {
                if (menuRef && menuRef !== excludeMenuRef && menuRef.closeSubMenu) {
                    menuRef.closeSubMenu();
                }
            });
        }
    };

    // Fornecer as funções para os componentes filhos
    provide(PROVIDE_KEYS.CLOSE_OTHER_SUBMENUS, menuUtils.closeOthers);
    provide(PROVIDE_KEYS.REGISTER_SUBMENU, menuUtils.register);
</script>

<style lang="scss" scoped>
    .menus{
        width: 100%;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        padding: 28px 21px 1.5em 21px; /* Sem padding-top, deixa o container pai controlar */
        gap: 0.5em;
    }
</style>